import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

export const getPrices = () => ({
  domesticShipping: '7.80',
  internationalShipping: '17.15'
});

export const withPrices = (Component) => {
    const values = getPrices();
    const WrappedComponent = ((props) =>
      <Component prices={values} {...props} />
    );
    hoistNonReactStatics(WrappedComponent, Component);
    return WrappedComponent;
};



// WEBPACK FOOTER //
// ./src/service/prices.js